import React from 'react';
import PropTypes from 'prop-types';
import { ProfileSettingsConfig } from '@Constants/rx-user/constants';
import Button from '@Components/Button';
import Input from '@Components/Input';

function PreferredSuppliersHeadingOpened({ checkedCount, onReset, onClose, searchValue, setSearchValue }) {
  const handleResetClick = (e) => {
    e.stopPropagation();
    onReset();
  };

  const handleInputClick = (e) => {
    e.stopPropagation();
  };

  return (
    // eslint-disable-next-line jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions
    <div className="preferred-suppliers-accordion-item__heading rx-accordion-row profile-settings-accordion-row" onClick={onClose}>
      <span className="profile-settings-accordion-row_label">
        {ProfileSettingsConfig.Labels.preferredSuppliers}
        {checkedCount > 0 && <span className="preferred-suppliers-accordion-item__checked-count">{checkedCount}</span>}
      </span>
      <div className="preferred-suppliers-accordion-item__controls">
        {/* eslint-disable-next-line jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions */}
        <div onClick={handleInputClick}>
          <Input
            className="preferred-suppliers-accordion-item__search-input"
            placeholder="Search by name"
            value={searchValue}
            onChange={setSearchValue}
            debounceDelay={0}
          />
        </div>
        <Button
          onClick={handleResetClick}
          buttonConfig={{
            className: 'preferred-suppliers-accordion-item__reset-button',
            type: 'link',
            size: 'sm',
            iconOnly: true,
            ariaLabel: 'Reset',
            e2eName: 'preferred-suppliers-reset',
          }}
          iconConfig={{
            name: 'replay',
          }}
        />
        <Button
          buttonConfig={{
            className: 'preferred-suppliers-accordion-item__close-button',
            type: 'link',
            size: 'sm',
            iconOnly: true,
            ariaLabel: 'Close',
            e2eName: 'preferred-suppliers-close',
          }}
          iconConfig={{
            name: 'delete',
          }}
        />
      </div>
    </div>
  );
}

PreferredSuppliersHeadingOpened.defaultProps = {
  onReset: () => {},
  onClose: () => {},
  setSearchValue: () => {},
};

PreferredSuppliersHeadingOpened.propTypes = {
  checkedCount: PropTypes.number,
  onReset: PropTypes.func,
  onClose: PropTypes.func,
  searchValue: PropTypes.string,
  setSearchValue: PropTypes.func,
};

export default PreferredSuppliersHeadingOpened;
